import { render, staticRenderFns } from "./AddPortalContent.vue?vue&type=template&id=00fae334&"
import script from "./AddPortalContent.vue?vue&type=script&lang=js&"
export * from "./AddPortalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports